module.exports = __webpack_public_path__ + "static/media/B3.de831424.jpg";